import { useSwiper } from "swiper/react";
import { ReactComponent as Arrow } from "@assets/images/arrow.svg";
import classes from "./Arrows.module.scss";

const Arrows = () => {
  const swiper = useSwiper();

  const handlePrev = () => {
    swiper.slidePrev();
  };

  const handleNext = () => {
    swiper.slideNext();
  };

  return (
    <div className={classes.arrows}>
      <button onClick={handlePrev}>
        <Arrow style={{ transform: "rotate(180deg)" }} />
      </button>
      <button onClick={handleNext}>
        <Arrow />
      </button>
    </div>
  );
};

export default Arrows;
